import { Fab } from 'react-tiny-fab';
import { useState, useEffect } from 'react';
import LightColors from '../../constants/LightColors';
import { ReactComponent as PlusIcon } from '../../icons/plus.svg';
import RegularSolidButton from '../buttons/RegularSolidButton';
import bubbleTailSvg from '../../icons/graphic.ui.bubbletail.svg';

export const PopupFabButton = ({
  onClickFabChildrenButton,
  buttonTexts,
  messageBubbleText,
  marginBottom = 64
}) => {
  const [isOpenFab, setIsOpenFab] = useState(false);

  const handleClick = (e) => {
    setIsOpenFab(!isOpenFab);
  };

  const handleClickFabChildrenButton = (index) => {
    if (onClickFabChildrenButton) {
      onClickFabChildrenButton(index);
    }
  };

  return (
    <>
      {/* 말풍선 - CSS로 표시/숨김 제어 */}
      {messageBubbleText && (
        <div
          className={`fixed z-[100] transition-all duration-300 ease-in-out ${
            isOpenFab
              ? 'opacity-0 pointer-events-none'
              : 'opacity-100 animate-in fade-in slide-in-from-bottom-2'
          }`}
          style={{
            bottom: `calc(env(safe-area-inset-bottom) + ${marginBottom + 92}px)`,
            right: '23px',
            transitionDelay: isOpenFab ? '0s' : '0.3s' // 닫힐 때 0.3초 후에 나타남
          }}
        >
          <PopButtonMessageBubble messageBubbleText={messageBubbleText} />
        </div>
      )}

      {/* FAB 버튼 */}
      <div
        onClick={(e) => {
          // FAB 버튼 내부에서 클릭된 경우에만 실행
          if (e.target.closest('[role="button"]')) {
            handleClick(e);
          }
        }}
        role="none"
      >
        <Fab
          alwaysShowTitle={false}
          style={{ bottom: `calc(env(safe-area-inset-bottom) + ${marginBottom}px)`, right: 0 }}
          icon={<PlusIcon className="fill-pure-white" width={'24px'} height={'24px'} />}
          mainButtonStyles={{
            backgroundColor: LightColors.primary,
            boxShadow:
              '0px 0px 4px 0px rgba(92, 61, 250, 0.40), 0px 2px 10px 0px rgba(92, 61, 250, 0.30)'
          }}
          event="click"
        >
          {buttonTexts?.map((buttonText, index) => (
            <div key={buttonText}>
              <RegularSolidButton
                paddingX={'24px'}
                paddingY={'16px'}
                fontSize={'17px'}
                lineHeight={'20px'}
                text={buttonText}
                style={{
                  boxShadow:
                    '0px 0px 4px 0px rgba(92, 61, 250, 0.40), 0px 2px 10px 0px rgba(92, 61, 250, 0.30)'
                }}
                onClicked={() => handleClickFabChildrenButton(index)}
              />
            </div>
          ))}
        </Fab>
      </div>
    </>
  );
};

const PopButtonMessageBubble = ({ messageBubbleText }) => {
  return (
    <div className="relative inline-block">
      <div
        className="px-[10px] py-[7px] rounded-[4px] w-fit"
        style={{ background: 'linear-gradient(90deg, #FF45A9 0%, #FF6A6A 100%)' }}
      >
        <p className="text-pure-white text-[12px] font-medium whitespace-nowrap">
          {messageBubbleText}
        </p>
      </div>
      {/* 아래쪽 꼬리 */}
      <img
        src={bubbleTailSvg}
        className="absolute -bottom-[5.5px] right-[23px]"
        width={10}
        height={16}
        alt="bubble tail"
      />
    </div>
  );
};
